
import React from 'react'
import { Package, DollarSign, AlertTriangle, TrendingUp } from 'lucide-react'

interface MetricsCardProps {
  title: string
  value: string | number
  icon: React.ReactNode
  color: string
  bgColor: string
}

const MetricsCard: React.FC<MetricsCardProps> = ({ title, value, icon, color, bgColor }) => (
  <div className={`${bgColor} rounded-lg p-6 shadow-sm border`}>
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
        <p className={`text-2xl font-bold ${color}`}>{value}</p>
      </div>
      <div className={`${color} opacity-80`}>
        {icon}
      </div>
    </div>
  </div>
)

interface MetricsProps {
  title: string
  value: string | number
  icon: any
  color: string
}

export const MetricsCardInsumos: React.FC<MetricsProps> = ({ title, value, icon: Icon, color }) => {
  const getColorClasses = (colorName: string) => {
    switch (colorName) {
      case 'blue':
        return { text: 'text-blue-600', bg: 'bg-blue-50' }
      case 'green':
        return { text: 'text-green-600', bg: 'bg-green-50' }
      case 'red':
        return { text: 'text-red-600', bg: 'bg-red-50' }
      case 'purple':
        return { text: 'text-purple-600', bg: 'bg-purple-50' }
      default:
        return { text: 'text-gray-600', bg: 'bg-gray-50' }
    }
  }

  const colors = getColorClasses(color)

  return (
    <div className={`${colors.bg} rounded-lg p-6 shadow-sm border`}>
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className={`text-2xl font-bold ${colors.text}`}>{value || 0}</p>
        </div>
        <div className={`${colors.text} opacity-80`}>
          <Icon size={24} />
        </div>
      </div>
    </div>
  )
}

export default MetricsCardInsumos
